Object.defineProperty(String.prototype, "capitalize", {
  enumerable: false,
  value: function (string) {
    return string.replace(/(^|\s)\S/g, function (a) {
      return a.toUpperCase();
    });
  },
});
